// Always import {h} from preact
import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import {
  addToCart,
  findVariant,
  findProduct,
  OPTION,
  TYPE,
} from "../utils/product";
import ShopCta from "./ShopCta";
import ShopOption from "./ShopOption";

const TrialShop = ({ products, optionSubText }) => {
  //
  // Define current selection as state
  //
  const [option, setOption] = useState(OPTION.capsule);
  const type = TYPE.subscription;

  const quantity = 1; //fixed value for trial

  //
  // Define product and variant
  //
  const product = findProduct(products, option, type, quantity);
  const variant = findVariant(product, quantity);

  //
  // Define other required data to render
  //
  const showOption =
    Array.isArray(optionSubText) &&
    optionSubText.length >= 2;
  // Determine if afterpay offer is applicable for this product

  const selectOption = (value) => {
    setOption(value);

    // When option changes, switch the images and title outside of shop section
    if (value === OPTION.gummy) {
      window.toggleToGummy();
    } else {
      window.toggleToCapsule();
    }
  };

  useEffect(() => {
    if (window.isGummyPdp) {
      selectOption(OPTION.gummy);
    }
  }, []);

  return (
    <div class="shop shop--flo-pms">
        <div class="shop__claims">
            <div class="shop__claims-claim">
                <img class="shop__claims-badge" src= 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/shop-checkmark.svg?v=1686006001' alt="verified"/>
                <p class="shop__claims-text">Free Shipping, cancel anytime</p>
            </div>
            <div class="shop__claims-claim">
                <img class="shop__claims-badge" src= 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/shop-checkmark.svg?v=1686006001' alt="verified"/>
                <p class="shop__claims-text"> First month $9.99, then $27.99/mo</p>
            </div>
        </div>
      <div class="shop__selection">
        {showOption && (
          <ShopOption
            option={option}
            optionSubText={optionSubText}
            selectOption={selectOption}
          />
        )}
      </div>
      <ShopCta
      // Hardcoded price + original price, change to metafield if we create more trial products
        price={9.99}
        originalPrice={34.99}
        noDecimals={false}
        ctaCopy = 'Unlock Offer - '
        addToCart={() => {
          addToCart(product, variant, type).then(() => {
            document.dispatchEvent(new Event('fetchAndSlideCart'));
          });
        }}
      />
      <p class="shop__happiness-guarantee shop__happiness-guarantee--og shop__happiness-guarantee--trial">
        1 Million+ Customers Served 
        <br> </br> 3,000+ Five-Star Reviews
      </p>
    </div>
  );
};

export default TrialShop;
